import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { CookieService } from 'ngx-cookie-service';

import { SmsDialogFormComponent } from './sms-dialog-form.component';

@NgModule({
  declarations: [SmsDialogFormComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    FlexLayoutModule,
  ],
  providers: [CookieService],
  exports: [SmsDialogFormComponent],
})
export class SmsDialogFormModule {}
